import * as React from "react";
import {VeboxModels} from "../types/veboxModels";
import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";

const VeboxUserContext = React.createContext<VeboxModels.User>({} as any);

interface VeboxUserProviderProps {
    onReceiveUserData?: (user: VeboxModels.User) => void;
}

export namespace VeboxUser {
    export const Provider: React.FC<VeboxUserProviderProps> = (props) => {

        const [user, setUser] = React.useState<VeboxModels.User>();

        React.useEffect(() => {
            getCurrentUser().then((u) => {
                setUser(u);
                if (props.onReceiveUserData) {
                    props.onReceiveUserData(u);
                }
            })
        }, []);

        return (
            <VeboxUserContext.Provider value={user}>
                {props.children}
            </VeboxUserContext.Provider>
        );
    }

    export const useCurrentUser = () => {
        return React.useContext(VeboxUserContext);
    }

    function getCurrentUser() {
        return new Promise<VeboxModels.User>((res, rej) => {
            RestDataLoader.loadData(
                "users/current",
                {},
                res,
                rej
            )
        })
    }
}